import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const TabView = ({
  label,
  className,
  href,
  onClick,
  tagName: Tag,
}) => {
  const Component = href ? Link : 'div';
  return (
    <Tag className={className}>
      <Component className="site-main-nav__item--link bvs-link" to={href} onClick={onClick}>
        {label}
      </Component>
    </Tag>
  );
};

TabView.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  tagName: PropTypes.string,
};

TabView.defaultProps = {
  tagName: 'li',
  href: null,
};

export default TabView;
